export interface BrandingConfig {
  appName?: string;
  /** Logo für helle Hintergründe. */
  logo?: string;
  /** Logo für dunkle Hintergründe (z. B. schwarze Toolbar). */
  logoDark?: string;
  /** Primäre Akzentfarbe – aktive Zustände, Buttons, Highlights. */
  accentColor?: string;
  /** Sekundäre Akzentfarbe – Hover-Zustände, weiche Highlights. */
  accentColorSecondary?: string;
}

export const BRANDING_DEFAULTS: Required<BrandingConfig> = {
  appName: 'Docuty',
  logo: '/assets/branding/logo-main.png',
  logoDark: '/assets/branding/logo-dark.png',
  accentColor: '#b9ff82',
  accentColorSecondary: '#e9f8d8',
};
